import { observable, action } from 'mobx'

class SortGoodsStore {
    @observable
    activeId: number | undefined = void 0

    @observable
    secondId: number = 0

    groupUpdate: boolean = false

    goodUpdate: boolean = false

    public setGroupUpdate(status: boolean = true) {
        this.groupUpdate = status
    }

    public setGoodUpdate(status: boolean = true) {
        this.goodUpdate = status
    }

    @action
    setActiveId(id: number | undefined) {
        this.activeId = id
    }

    @action
    setSecondId(id: number) {
        this.secondId = id
    }
}

export const sortGoodStore = new SortGoodsStore()
